module.exports = __webpack_public_path__ + "static/media/bg_1.c32523bc.jpg";